import { z } from 'zod'

const otelEnvSchema = z.object({
  OTEL_ENABLED: z.coerce.boolean().default(false),
  OTEL_SERVICE_NAME: z.string().default('nexus'),
  OTEL_PROMETHEUS_PORT: z.coerce.number().int().min(0).max(65535).default(9464),
  OTEL_EXPORTER_OTLP_ENDPOINT: z.string().url().optional(),
  OTEL_TRACE_SAMPLE_RATE: z.coerce.number().min(0).max(1).default(1.0)
})

export interface OtelConfig {
  enabled: boolean
  serviceName: string
  prometheusPort: number
  otlpEndpoint?: string
  traceSampleRate: number
}

let cachedConfig: OtelConfig | null = null

export function getOtelConfig(): OtelConfig {
  if (cachedConfig) return cachedConfig

  const env = otelEnvSchema.parse(process.env)
  cachedConfig = {
    enabled: env.OTEL_ENABLED,
    serviceName: env.OTEL_SERVICE_NAME,
    prometheusPort: env.OTEL_PROMETHEUS_PORT,
    otlpEndpoint: env.OTEL_EXPORTER_OTLP_ENDPOINT,
    traceSampleRate: env.OTEL_TRACE_SAMPLE_RATE
  }
  return cachedConfig
}

/** Reset cached config (for testing) */
export function resetOtelConfig(): void {
  cachedConfig = null
}
